import type { Event, EventParticipantDetails } from "@lezz/shared";

/** Transform EventParticipantDetails → Event for use with EventCard */
export function toEvent(details: EventParticipantDetails): Event {
  return {
    eventId: details.eventId!,
    placeId: details.eventPlaceId!,
    title: details.eventTitle!,
    description: details.eventDescription!,
    dateAndTime: details.eventDateAndTime!,
    address: details.eventAddress!,
    city: details.eventCity!,
    state: details.eventState!,
    country: details.eventCountry!,
    imageUrl: details.eventImageUrl ?? null,
    hostName: details.eventHostName ?? null,
    hostSocialUrl: details.eventHostSocialUrl ?? null,
    isPaid: details.eventIsPaid ?? null,
    ticketPurchaseUrl: details.eventTicketPurchaseUrl ?? null,
    musicTags: details.eventMusicTags ?? null,
    venueTags: details.eventVenueTags ?? null,
    eventTags: details.eventEventTags ?? null,
    createdAt: details.eventCreatedAt!,
    updatedAt: details.eventUpdatedAt!,
    lat: null,
    lng: null,
    // event_participant_details doesn't carry coupon_label, so this can never be true.
    couponLabel: null,
    hasCoupon: false,
    hasCouponCode: false,
  };
}
